export enum FrontEndErrMsgs {
    reqHeading = 'msg.cs818.text',
    serialNum = 'label.gb.serial_number',
    implantPhyIdName = 'label.gb.doc_perform_implant',
    productId = 'label.gb.dev_name',
    productName = 'label.gb.dev_name',
    firstName = 'label.gb.firstname',
    lastName = 'label.gb.lastname',
    dateOfBirthStr = 'label.gb.date_of_birth',
    patientId = 'label.gb.pat_record_no',
    patientNum = 'label.gb.pat_record_no',
    number = 'label.gb.primary_phone',
    zipCode = 'label.gb.zip_post_code',
    areaCode = 'label.gb.phone_area_code',
    implantDate = 'label.gb.implant_date',
    address = 'label.gb.address',
    city = 'label.gb.city',
    name = 'label.gb.clinicname',
    countryCode = 'label.gb.phone_country_code',
    implantPhyId = 'label.gb.doc_perform_implant',
    stateCd = 'label.gb.state_province',
    state = 'label.gb.state_province',
    email = 'label.gb.email',
    transmitterModelNum = 'label.gb.tranmsitter_model',
    transmitterSerialNumber = 'label.gb.trans_serial_no',
    baseLineDate = 'label.gb.date_baseline_taken',
    locationName = 'label.gb.cliniclocation',
    phoneNum = 'label.gb.primary_phone_mobile',
    mainPhone = 'label.gb.main_phone',
    onCallSecurityStamp = 'label.gb.security_stamp',
    invalidBaseLineDate = 'msg.pa885.text',
    medicalSMS = 'Medical SMS',
    timeZoneCd = 'label.gb.clinic_time_zone',
    unpairedTransReportDistList = 'label.gb.unpaired_transmitter_recipients',
    localeCd = 'label.gb.language',
    msgEndTime = 'label.gb.and',
    msgStartTime = 'label.gb.between',
    emailAddress = 'label.gb.email',
    patientCallSMS = 'label.gb.other_phone',
    onCallEmail = 'label.gb.on_call_email',
    onCallFaxDetails = 'label.gb.on_call_fax',
    onCallPhoneDetails = 'label.gb.on_call_phone',
    onCallPhoneId = 'label.gb.on_call_phone',
    onCallSms = 'label.gb.on_call_SMS',
    onCallFaxId = 'label.gb.on_call_fax',
    countryCd = 'label.gb.country',
    leadChmbSettingCd = 'label.gb.lead_chamber',
    invalidField = 'msg.cs816.text',
    requiredField = 'msg.cs818.text',
    incorrectPhoneField = 'data.Code.Phone_Type_Cd.Code_Desc.PRIM',
    homePhone = 'label.gb.home_phone',
    sms = 'label.gb.text_msg_id',
    genderCd = 'label.gb.gender',
    drSerialNum = 'label.gb.serial_number',
    drProductId = 'label.gb.dev_name',
    drProductName = 'label.gb.dev_name',
}
